import styled from "styled-components";

const FileItem = styled.div`
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.base2};
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    padding: 0;
    height: 24px;
    width: 24px;
    border: none;
    background: none;
    cursor: pointer;
  }
  img {
    user-select: none;
  }
`;

export default FileItem;
